<template>
  <div class="loginForm modal fade" id="customerModal">
    <row class="modal-dialog" role="document" style="width: 100%">
      <column class="col-md-4"></column>
      <column class="col-md-4">
        <va-box :title="title" theme="box-info" :isBorder="true" widgetType="">
          <div slot="content">
            <div v-if="0>1" class="col-md-6">
              <va-box title="Customer Info" :isBorder="true" theme="box-warning" widgetType="">
                <div slot="content">
                  <form class="form-horizontal">
                    <div class="form-group">
                      <label class="col-sm-3 control-label">Customer Name</label>
                      <div class="col-sm-8">
                        <input type="text" readonly class="form-control" placeholder="Customer Name" :value="name" />
                      </div>
                    </div>
                    <!--<div class="form-group">
                      <label class="col-sm-4 control-label">Email</label>
                      <div class="col-sm-8">
                        <input type="email" class="form-control" placeholder="Email" v-model="email" />
                      </div>
                    </div>-->
                    <!--<div class="form-group">
                      <label class="col-sm-4 control-label">Phone</label>
                      <div class="col-sm-8">
                        <input type="email" class="form-control" placeholder="Phone" v-model="phone" />
                      </div>
                    </div>-->
                    <div class="form-group">
                      <label class="col-sm-4 control-label">Password</label>
                      <div class="col-sm-8">
                        <input type="password" class="form-control" placeholder="Password" v-model="password" />
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-4 control-label">Confirm Password</label>
                      <div class="col-sm-8">
                        <input type="password" class="form-control" placeholder="Confirm Password" v-model="confirmPassword" />
                      </div>
                    </div>
                  </form>
                </div>
              </va-box>
            </div>

            <div>
              <va-box title="Customer Info" :isBorder="true" theme="box-warning" widgetType="">
                <div slot="content">
                  <form class="form-horizontal">

                    <div class="form-group">
                      <label class="col-sm-4 control-label" style="text-align: left;">Customer Name</label>
                      <div class="col-sm-8">
                        <input type="text" readonly class="form-control" placeholder="Customer Name" :value="name" />
                      </div>
                    </div>

                    <!--<div class="form-group">
                      <label class="col-sm-4 control-label" style="text-align: left;">Email</label>
                      <div class="col-sm-8">
                        <input type="email" class="form-control" placeholder="Email" v-model="email" />
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-4 control-label" style="text-align: left;">Phone</label>
                      <div class="col-sm-8">
                        <input type="email" class="form-control" placeholder="Phone" v-model="phone" />
                      </div>
                    </div>-->

                  </form>
                </div>
              </va-box>


              <va-box title="Search new printers scheduler" :isBorder="true" theme="box-warning" widgetType="">
                <div slot="content">
                  <form class="form-horizontal">
                    <div class="form-group">
                      <label class="col-sm-4 control-label" style="text-align: left;">Trigger: </label>
                      <div class="col-sm-5">
                        <select class="form-control" v-model="settings.SearchTrigger" style="padding-left: 0px; text-align: center;">
                          <option value="DAILY">DAILY</option>
                          <option value="WEEKLY">WEEKLY</option>
                          <option value="MONTHLY">MONTHLY</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group" v-show="settings.SearchTrigger==='MONTHLY'">
                      <label class="col-sm-4 control-label" style="text-align: left;">On Day: </label>
                      <div class="col-sm-5">
                        <select class="form-control" v-model="settings.SearchRunOnDay" style="padding-left: 0px; text-align: center;">
                          <option v-for="day in days" :value="day">{{day}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-4 control-label" style="text-align: left;">On Time: </label>
                      <div class="col-sm-5">
                        <select class="form-control" v-model="settings.SearchRunOnTime" style="padding-left: 0px; text-align: center;">
                          <option v-for="hour in hours" :value="hour">{{hour}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group form-horizontal" v-show="settings.SearchTrigger==='WEEKLY'">
                      <label class="col-sm-4 control-label" style="text-align: left;">On Day: </label>
                      <div class="col-sm-6">
                        <div class="checkbox inline" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" v-model="SearchRunOnWeek[0]" />SUN</label>
                        </div>
                        <div class="checkbox" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" v-model="SearchRunOnWeek[1]" />MON</label>
                        </div>
                        <div class="checkbox" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" v-model="SearchRunOnWeek[2]" />TUE</label>
                        </div>
                        <div class="checkbox" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" v-model="SearchRunOnWeek[3]" />WED</label>
                        </div>
                        <div class="checkbox" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" v-model="SearchRunOnWeek[4]" />THE</label>
                        </div>
                        <div class="checkbox" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" v-model="SearchRunOnWeek[5]" />FRI</label>
                        </div>
                        <div class="checkbox" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" v-model="SearchRunOnWeek[6]" />SAT</label>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </va-box>
              <va-box title="Get printers info scheduler" :isBorder="true" theme="box-warning" widgetType="">
                <div slot="content">
                  <form class="form-horizontal">
                    <div class="form-group">
                      <label class="col-sm-4 control-label" style="text-align: left;">Trigger: </label>
                      <div class="col-sm-5">
                        <select class="form-control" v-model="settings.SendTrigger" style="padding-left: 0px; text-align: center;">
                          <option value="DAILY">DAILY</option>
                          <option value="WEEKLY">WEEKLY</option>
                          <option value="MONTHLY">MONTHLY</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group" v-show="settings.SendTrigger==='MONTHLY'">
                      <label class="col-sm-4 control-label" style="text-align: left;">On Day: </label>
                      <div class="col-sm-5">
                        <select class="form-control" v-model="settings.SendRunOnDay" style="padding-left: 0px; text-align: center;">
                          <option v-for="day in days" :value="day">{{day}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-4 control-label" style="text-align: left;">On Time: </label>
                      <div class="col-sm-5">
                        <select class="form-control" v-model="settings.SendRunOnTime" style="padding-left: 0px; text-align: center;">
                          <option v-for="hour in hours" :value="hour">{{hour}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group form-horizontal" v-show="settings.SendTrigger==='WEEKLY'">
                      <label class="col-sm-4 control-label" style="text-align: left;">On Day: </label>
                      <div class="col-sm-6">
                        <div class="checkbox inline" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" value="SUN" v-model="SendRunOnWeek[0]" />SUN</label>
                        </div>
                        <div class="checkbox" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" value="MON" v-model="SendRunOnWeek[1]" />MON</label>
                        </div>
                        <div class="checkbox" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" value="TUE" v-model="SendRunOnWeek[2]" />TUE</label>
                        </div>
                        <div class="checkbox" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" value="WED" v-model="SendRunOnWeek[3]" />WED</label>
                        </div>
                        <div class="checkbox" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" value="THE" v-model="SendRunOnWeek[4]" />THE</label>
                        </div>
                        <div class="checkbox" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" value="FRI" v-model="SendRunOnWeek[5]" />FRI</label>
                        </div>
                        <div class="checkbox" style="display: inline-block; margin-right: 10px;">
                          <label><input type="checkbox" value="SAT" v-model="SendRunOnWeek[6]" />SAT</label>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </va-box>
              <va-box title="Printers status" :isBorder="true" theme="box-warning" widgetType="">
                <div slot="content">
                  <form class="form-horizontal">
                    <div class="form-group">
                      <label class="col-sm-4 control-label" style="text-align: left;">Check printers status every </label>
                      <div class="col-sm-5">
                        <input type="number" min="1" max="1000" class="form-control" style="text-align: center;" v-model="settings.CheckStatusEvery" />
                      </div>
                      <label class="col-sm-1 control-label" style="text-align: left;">minutes </label>
                    </div>
                  </form>
                </div>
              </va-box>
            </div>
            <div class="col-md-12">
              <div class="form-group" align="center">
                <va-alert type="danger" :dismissible="false" v-show="error" style="width: 98%;">
                  <div slot="body">
                    <i class="icon fa fa-ban"></i> {{error}}
                  </div>
                </va-alert>
              </div>
            </div>
          </div>
          <div slot="footer">
            <va-button :isBlock="false" theme="danger" name="Cancel" align="right" @click.native="cancel"></va-button>
            <va-button :isBlock="false" theme="success" name="Save" align="right" @click.native="save" style="margin-right: 10px;"></va-button>
          </div>
        </va-box>
      </column>
      <column class="col-md-4"></column>
    </row>
  </div>
</template>
<script>
  import VAAlert from './VAAlert'
  import VABox from './VABox'
  import VAButton from './VAButton'
  import VACheckBox from './VACheckBox'
  import { db, dbListener } from '../firebase'
  export default {
    name: 'AddCustomer',
    components: {
      'va-alert': VAAlert,
      'va-box': VABox,
      'va-button': VAButton,
      'va-checkbox': VACheckBox
    },
    data () {
      return {
        hours: [],
        days: [],
        checkSUN: true,
        customerKey: '',
        title: 'Add Customer',
        password: '',
        confirmPassword: '',
        phone: '',
        address: '',
        totalSites: 0,
        totalPrinters: 0,
        error: '',
        SearchRunOnWeek: [false, false, false, false, false, false, false],
        SendRunOnWeek: [false, false, false, false, false, false, false],
        settings: {
          CheckStatusEvery: 120,
          SearchRunOnDay: 28,
          SearchRunOnTime: '07:00',
          SearchRunOnWeek: 'SUN',
          SearchTrigger: 'WEEKLY',
          SendRunOnDay: 28,
          SendRunOnTime: '16:30',
          SendRunOnWeek: 'SAT',
          SendTrigger: 'MONTHLY',
          Name: '',
          Email: '',
          Phone: ''
        }
      }
    },
    watch: {
      'settings.CheckStatusEvery' (val) {
        if (isNaN(val)) {
          this.settings.CheckStatusEvery = 60
        } else {
          if (val < 1) {
            this.settings.CheckStatusEvery = 1
          }
          if (val > 1000) {
            this.settings.CheckStatusEvery = 1000
          }
        }
      }
    },
    created () {
      for (let t = 0; t <= 23; t++) {
        if (t < 10) {
          this.hours.push('0' + t + ':00')
          this.hours.push('0' + t + ':30')
        } else {
          this.hours.push(t + ':00')
          this.hours.push(t + ':30')
        }
      }
      for (let d = 1; d <= 28; d++) {
        this.days.push(d)
      }
    },
    mounted () {
      this.$bus.$on('customerModal-open', (args) => {
        console.log(args)
        if (args) {
          this.title = 'Edit Customer' + ' [' + args.Name + ']'
          this.customerKey = args['.key']
          this.name = args.settings.Name ? args.settings.Name : ''
          this.email = args.settings.Email ? args.settings.Email : ''
          this.phone = args.settings.Phone ? args.settings.Phone : ''
          this.address = args.Address
          this.totalSites = args.TotalSites
          this.totalPrinters = args.TotalPrinters
          console.log(args.settings)
          if (args.settings) {
            this.settings = args.settings
            if (this.settings.SearchRunOnWeek) {
              let daysArr = this.settings.SearchRunOnWeek.split(',')
              console.log(daysArr)
              for (let i = 0; i < daysArr.length; i++) {
                switch (daysArr[i]) {
                  case 'SUN': this.SearchRunOnWeek[0] = true; break
                  case 'MON': this.SearchRunOnWeek[1] = true; break
                  case 'TUE': this.SearchRunOnWeek[2] = true; break
                  case 'WED': this.SearchRunOnWeek[3] = true; break
                  case 'THE': this.SearchRunOnWeek[4] = true; break
                  case 'FRI': this.SearchRunOnWeek[5] = true; break
                  case 'SAT': this.SearchRunOnWeek[6] = true; break
                }
              }
            }
            if (this.settings.SendRunOnWeek) {
              let daysArr = this.settings.SendRunOnWeek.split(',')
              console.log(daysArr)
              for (let i = 0; i < daysArr.length; i++) {
                switch (daysArr[i]) {
                  case 'SUN': this.SendRunOnWeek[0] = true; break
                  case 'MON': this.SendRunOnWeek[1] = true; break
                  case 'TUE': this.SendRunOnWeek[2] = true; break
                  case 'WED': this.SendRunOnWeek[3] = true; break
                  case 'THE': this.SendRunOnWeek[4] = true; break
                  case 'FRI': this.SendRunOnWeek[5] = true; break
                  case 'SAT': this.SendRunOnWeek[6] = true; break
                }
              }
            }
          }
          this.error = ''
        } else {
          this.title = 'Add Customer'
        }
        $('#customerModal').modal('show')
      })
    },
    methods: {
      save () {
        let vm = this
        if (vm.isValid()) {
            // const customer = {
            // Name: vm.name,
            // Email: vm.email ? vm.email : '',
            // Phone: vm.phone ? vm.phone : '',
            // Password: vm.password ? vm.password : '',
            // Address: vm.address ? vm.address : '',
            // TotalSites: vm.totalSites ? vm.totalSites : 0,
            // TotalPrinters: vm.totalPrinters ? vm.totalPrinters : 0
            // }
          vm.settings.SearchRunOnWeek = ''
          for (let i = 0; i < vm.SearchRunOnWeek.length; i++) {
            if (vm.SearchRunOnWeek[i]) {
              switch (i) {
                case 0: vm.settings.SearchRunOnWeek += 'SUN,'; break
                case 1: vm.settings.SearchRunOnWeek += 'MON,'; break
                case 2: vm.settings.SearchRunOnWeek += 'TUE,'; break
                case 3: vm.settings.SearchRunOnWeek += 'WED,'; break
                case 4: vm.settings.SearchRunOnWeek += 'THE,'; break
                case 5: vm.settings.SearchRunOnWeek += 'FRI,'; break
                case 6: vm.settings.SearchRunOnWeek += 'SAT,'; break
              }
            }
          }
          if (vm.settings.SearchRunOnWeek.length > 0) {
            vm.settings.SearchRunOnWeek = vm.settings.SearchRunOnWeek.slice(0, -1)
          }
          vm.settings.SendRunOnWeek = ''
          for (let i = 0; i < vm.SendRunOnWeek.length; i++) {
            if (vm.SendRunOnWeek[i]) {
              switch (i) {
                case 0: vm.settings.SendRunOnWeek += 'SUN,'; break
                case 1: vm.settings.SendRunOnWeek += 'MON,'; break
                case 2: vm.settings.SendRunOnWeek += 'TUE,'; break
                case 3: vm.settings.SendRunOnWeek += 'WED,'; break
                case 4: vm.settings.SendRunOnWeek += 'THE,'; break
                case 5: vm.settings.SendRunOnWeek += 'FRI,'; break
                case 6: vm.settings.SendRunOnWeek += 'SAT,'; break
              }
            }
          }
          if (vm.settings.SendRunOnWeek.length > 0) {
            vm.settings.SendRunOnWeek = vm.settings.SendRunOnWeek.slice(0, -1)
          }
          if (vm.customerKey) {
            vm.settings.Name = vm.name
            vm.settings.Email = vm.email
            vm.settings.Phone = vm.phone
            console.log(vm.settings)
            console.log(vm.customerKey)
            db.ref('Settings/CustomerSettings/' + vm.customerKey).set(vm.settings).then(function (result) {
              console.log(vm.settings)
              console.log('Settings/CustomerSettings Saved!')
            }).catch(function (err) {
              console.log('Settings/CustomerSettings Failed !!!')
              console.log(err)
            })
            // db.ref('CustomerSettings/' + vm.customerKey).set(vm.settings)
            // db.ref('UpdateClient/' + vm.customerKey + '/RefreshSettings').set(true)
            const sitesPath = 'Dealers/' + vm.$parent.filters.dealerKey + '/Customers/' + vm.customerKey + '/Sites'
            const sitesRef = db.ref(sitesPath)
            sitesRef.once('value').then(function (snapItems) {
              const data = snapItems.val()
              if (data) {
                const sitesKeys = Object.keys(data)
                for (let i = 0; i < sitesKeys.length; i++) {
                  let siteKey = sitesKeys[i]
                  if (siteKey) {
                    dbListener.ref('UpdateClient/' + siteKey + '/RefreshSettings').set(true)
                  }
                }
              }
            })
          } else {
            console.log('Error::: Missing CustomerKey')
          }
          if (vm.customerKey === 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX') {
            db.ref('Settings/CustomerSettings/' + vm.customerKey).set(vm.settings)
            for (let i = 0; i < vm.$root.slideItems.length; i++) {
              let slideItem = vm.$root.slideItems[i]
              if (slideItem) {
                if (slideItem.items && slideItem.items.length > 0) {
                  for (let j = 0; j < slideItem.items.length; j++) {
                    let item = slideItem.items[j]
                    if (item) {
                      if (vm.$root.isAdmin) {
                        if (item.key === vm.customerKey) {
                          if (item.subItems && item.subItems.length > 0) {
                            for (let k = 0; k < item.subItems.length; k++) {
                              let subItem = item.subItems[k]
                              if (subItem) {
                                if (subItem.computer) {
                                  // db.ref('UpdateClient/' + vm.customerKey + '/RefreshSettings').set(true)
                                  console.log('vm.$root.slideItems[' + i + '].items[' + j + '].subItems[' + k + '].computer = ' + subItem.computer)
                                } else {
                                  console.log('Error::: vm.$root.slideItems[' + i + '].items[' + j + '].subItems[' + k + '].computer = ' + subItem.computer)
                                }
                              } else {
                                console.log('Error::: vm.$root.slideItems[' + i + '].items[' + j + '].subItems[' + k + '] = ' + subItem)
                              }
                            }
                          }
                        }
                      } else {
                        if (item.computer) {
                          // db.ref('UpdateClient/' + item.key + '/RefreshSettings').set(true)
                          console.log('vm.$root.slideItems[' + i + '].items[' + j + '].computer = ' + item.computer)
                        } else {
                          console.log('Error::: vm.$root.slideItems[' + i + '].items[' + j + '].computer = ' + item.computer)
                        }
                      }
                    } else {
                      console.log('Error::: vm.$root.slideItems[' + i + '].items[' + j + '] is : ' + slideItem.items[j])
                    }
                  }
                } else {
                  console.log('Error::: vm.$root.slideItems[' + i + '].items is : ' + slideItem.items)
                }
              } else {
                console.log('Error::: vm.$root.slideItems[' + i + '] is : ' + slideItem)
              }
            }
          } else {
            console.log('Error::: Missing Customer Key')
          }
          vm.$root.loadSlideItems()
          vm.reset()
          $('#customerModal').modal('hide')
        }
      },
      cancel () {
        this.reset()
        $('#customerModal').modal('hide')
      },
      isValid () {
        this.error = ''
        if (this.settings.SearchTrigger === 'WEEKLY') {
          let count = 0
          for (let i = 0; i < this.SearchRunOnWeek.length; i++) {
            if (this.SearchRunOnWeek[i]) {
              count++
            }
          }
          if (count === 0) {
            this.error = '* Please select at least one day from [Search new printers scheduler] section!'
            return false
          }
        }
        if (this.settings.SendTrigger === 'WEEKLY') {
          let count = 0
          for (let i = 0; i < this.SendRunOnWeek.length; i++) {
            if (this.SendRunOnWeek[i]) {
              count++
            }
          }
          if (count === 0) {
            this.error = '* Please select at least one day from [Get printers info scheduler] section!'
            return false
          }
        }
        return true
      },
      isValid_OLD () {
        this.error = ''
        if (this.settings.SearchTrigger === 'WEEKLY') {
          let count = 0
          for (let i = 0; i < this.SearchRunOnWeek.length; i++) {
            if (this.SearchRunOnWeek[i]) {
              count++
            }
          }
          if (count === 0) {
            this.error = '* Please select at least one day from [Search new printers scheduler] section!'
            return false
          }
        }
        if (this.settings.SendTrigger === 'WEEKLY') {
          let count = 0
          for (let i = 0; i < this.SendRunOnWeek.length; i++) {
            if (this.SendRunOnWeek[i]) {
              count++
            }
          }
          if (count === 0) {
            this.error = '* Please select at least one day from [Get printers info scheduler] section!'
            return false
          }
        }
        if (!this.name || this.name.length === 0) {
          this.error = '* Please enter Customer Name!'
          return false
        }
        if (!this.email || this.email.length === 0) {
          this.error = '* Please enter Customer Email!'
          return false
        }
        if (!this.password || this.password.length === 0) {
          this.error = '* Please enter Customer Password!'
          return false
        }
        if (!this.confirmPassword || this.confirmPassword.length === 0) {
          this.error = '* Please enter Customer Password!'
          return false
        }
        if (this.confirmPassword !== this.password) {
          this.error = '* Please confirm Customer Password!'
          return false
        }
        return true
      },
      reset () {
        this.customerKey = ''
        this.title = 'Add Customer'
        this.name = ''
        this.email = ''
        this.password = ''
        this.confirmPassword = ''
        this.phone = ''
        this.address = ''
        this.error = ''
        this.totalSites = 0
        this.totalPrinters = 0
        this.settings = {
          CheckStatusEvery: 120,
          SearchRunOnDay: 28,
          SearchRunOnTime: '07:00',
          SearchRunOnWeek: 'SUN',
          SearchTrigger: 'WEEKLY',
          SendRunOnDay: 28,
          SendRunOnTime: '16:30',
          SendRunOnWeek: 'SAT',
          SendTrigger: 'MONTHLY'
        }
        this.SearchRunOnWeek = [false, false, false, false, false, false, false]
        this.SendRunOnWeek = [false, false, false, false, false, false, false]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddCustomer.vue?307c2484